import { useEffect, useState } from 'react'
import School from './School/School'
import AcademyBranch from './Academy/AcademyBranch'
import { useProfileStore } from '../../store/useUserStore'
import { useTranslation } from 'react-i18next'

const Home = () => {
    const {homePageShow, setHomePageShow} = useProfileStore((state:any) => state)
    const [activeTab, setActiveTab] = useState(homePageShow) // school | academy
    const { t } = useTranslation()

    useEffect(() => {
        setActiveTab(homePageShow)
    }, [homePageShow])
    

    return (
        <>
        <div className="pb-16">
            <div className="flex border-b justify-around">
                <button onClick={() => {
                    setActiveTab("school")
                    setHomePageShow("school")
                }} className={`px-4 py-2 text-base font-medium ${ activeTab === "school" ? 'border-b-2 border-theme text-theme' : 'text-gray-500 hover:text-gray-700' }`} >
                    {t('school')}
                </button>
                <button onClick={() => {
                    setActiveTab("academy")
                    setHomePageShow("academy")
                }} className={`px-4 py-2 text-base font-medium ${ activeTab === "academy" ? 'border-b-2 border-theme text-theme' : 'text-gray-500 hover:text-gray-700' }`} >
                    {t('academy')}
                </button>
            </div>
            <div className="mt-4">
                {activeTab === "school" && <School />}
                {activeTab === "academy" && <AcademyBranch />}
            </div>
        </div>
        </>
    )
}

export default Home